import React, { Component } from 'react';
import { Commons } from 'components';
import cm from '../../helpers/commons';

// 두 좌표 사이 거리(m)를 하버사인 공식으로 계산. 좌표가 유효하지 않으면 null 반환.
// API에서 거리를 내려주기 전까지 프론트에서 직접 산출 (추후 API 대체 가능)
export const getDistanceMeter = (lat1, lon1, lat2, lon2) => {
  const coords = [lat1, lon1, lat2, lon2].map(Number);
  if (coords.some((v) => Number.isNaN(v)) || coords.every((v) => v === 0)) return null;

  const R = 6371000; // 지구 반경(m)
  const toRad = (deg) => (deg * Math.PI) / 180;
  const [rLat1, rLon1, rLat2, rLon2] = coords;
  const dLat = toRad(rLat2 - rLat1);
  const dLon = toRad(rLon2 - rLon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(rLat1)) * Math.cos(toRad(rLat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return Math.round(R * c);
};

class AffiliateStoreTable extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { togglestatus, onClick, storelist, pageclick } = this.props || {};
    const { data, response } = storelist || {};
    const { paging, store, office } = data || {};
    const { gpsLat: officeLat, gpsLon: officeLon } = office || {};

    const toggleOnTableData = {
      header: {
        main: [
          { data: '이름', textAlign: 'center' },
          { data: '거리(m)', textAlign: 'right' }
        ]
      },
      body: {
        main: null,
        message: '제휴식당 목록 내역이 존재하지 않습니다.'
      }
    };
    const toggleOffTableData = {
      header: {
        main: [
          { data: '시/도', textAlign: 'left' },
          { data: '시/군/구', textAlign: 'left' },
          { data: '동/리', textAlign: 'left' },
          { data: '이름', textAlign: 'left' },
          { data: '분류', textAlign: 'left' },
          { data: '주소', textAlign: 'left' },
          { data: '거리(m)', textAlign: 'right' },
          { data: '연락처', textAlign: 'left' }
        ]
      },
      body: {
        main: null,
        message: '제휴식당 목록 내역이 존재하지 않습니다.'
      }
    };

    let page = 1;
    let pagerow = 15;
    let totalcount = 0;

    if (data) {
      if (!Array.isArray(store)) return;

      page = paging.page;
      pagerow = paging.pagerow;
      totalcount = paging.totalcount;

      if (togglestatus) {
        toggleOnTableData.body.main = store.map((storeData) => {
          const distance = getDistanceMeter(officeLat, officeLon, storeData.gpsLat, storeData.gpsLon);
          const obj = {
            row: [
              { data: storeData.name, textAlign: 'center' },
              {
                data: distance === null ? '-' : cm.numberComma(distance),
                textAlign: 'right',
                fontColor: '#000000'
              }
            ]
          };
          return obj;
        });
      } else {
        toggleOffTableData.body.main = store.map((storeData) => {
          const distance = getDistanceMeter(officeLat, officeLon, storeData.gpsLat, storeData.gpsLon);
          const obj = {
            row: [
              { data: storeData.addressSido, textAlign: 'left' },
              { data: storeData.addressSigugun, textAlign: 'left' },
              { data: storeData.addressDongmyun, textAlign: 'left' },
              { data: storeData.name, textAlign: 'left' },
              { data: storeData.category, textAlign: 'left' },
              { data: storeData.address, textAlign: 'left' },
              {
                data: distance === null ? '-' : cm.numberComma(distance),
                textAlign: 'right',
                fontColor: '#000000'
              },
              { data: cm.phoneFormat(storeData.phone), textAlign: 'left' }
            ]
          };
          return obj;
        });
      }
    } else if (response) {
      toggleOffTableData.body.message = storelist.response.data.message;
    }

    return (
      <div>
        <Commons.TableForm
          togglestatus={togglestatus}
          onClick={onClick}
          tabledata={togglestatus ? toggleOnTableData : toggleOffTableData}
        />
        {togglestatus ? null : (
          <div className="table-paging">
            <Commons.Pagination
              page={page}
              pageRow={pagerow}
              pageBlock={10}
              totalCount={totalcount}
              pageClick={pageclick}
            />
          </div>
        )}
      </div>
    );
  }
}

export default AffiliateStoreTable;
